module.exports = __webpack_public_path__ + "static/profile3-e215e2eabf009ceafbce03ea32e91be2.png";